import React, { Component } from "react";
import _ from "lodash";
import { Modal, Button, Table } from "semantic-ui-react";

class DppaUse extends Component {
  componentDidMount() {}

  render() {
    const rows = [];
    _.forEach(this.props.dppas, (dppa, index) => {
      rows.push(
        <Table.Row key={`dppa_${index}`}>
          <Table.Cell>{dppa.text}</Table.Cell>
          <Table.Cell>{dppa.disc}</Table.Cell>
        </Table.Row>
      );
    });

    return (
      <Modal
        style={{
          width: "50%",
          marginLeft: "25%",
          marginTop: "20px",
          marginBottom: "20px",
          position: "relative",
        }}
        closeIcon
        open={this.props.active}
        onClose={() => this.props.closeDppaDialog()}
      >
        <Modal.Header>DPPA Use</Modal.Header>
        <Modal.Content image scrolling>
          <Modal.Description className={"width-50-percent"}>
            <Table className={"table-border-all"}>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>Name</Table.Cell>
                  <Table.Cell>Description</Table.Cell>
                </Table.Row>
                {rows}
              </Table.Body>
            </Table>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions className={"dialog-actions"}>
          <Button
            className={"no-background-color float-right"}
            onClick={() => this.props.closeDppaDialog()}
          >
            Done
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default DppaUse;



// WEBPACK FOOTER //
// ./src/components/dialogs/DppaUse.js